export const bwicPercentOfTrace = {
    margin: { t: 10, r: 0, b: 30, l: 30 },
    markerSize: 8,
    igMarkerColor: '#f0592a',
    hyMarkerColor: '#13396e',
    igLineColor: '#5c4f84',
    hyLineColor: '#b3c4d0',
    tickColor: '#e4e4e4',
    lineWidth: 3,
    font: {
        family: 'Roboto, Arial, Helvetica, sans-serif',
        size: 12,
        color: '#7f7f7f'
    },
    titlefont: {
        family: 'Roboto, Arial, Helvetica, sans-serif',
        size: 16,
        color: '#7f7f7f'
    },
    additionalValueInPercentagesForLastLine: 20,
    hoverlabel: {
        bgcolor: '#4a4a4a',
        bordercolor: '#4a4a4a',
        font: {
            color: '#ffffff',
            family: 'Roboto, Arial, Helvetica, sans-serif',
            size: 12
        },
        align: 'left'
    }
};
